import styled from "styled-components";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Message, Button, Icon } from "semantic-ui-react";

// import Select from "react-select";

import Upload from "./Upload";
import List from "./List";
import Details from "./Details";
import { BasicErrorMessage } from "utilities/ErrorMessages";

import { saveAs } from "file-saver";
import ContactBreadcrumb from "../ContactBreadcrumb";

import {
	LOAD_TEAMS,
	PULL_ORGANIZATION,
	SG_GET_FILE_UPLOADS,
	SG_GET_SURVEY_STRUCTURES,
	CLEAR_CREATED_FILE_UPLOAD,
	SG_VALIDATE_ORG_EMP_EMAIL,
	CLEAR_ERRORS,
} from "constants/actions";

const AllPageOptions = [
	{
		id: 1,
		name: "Contact upload lists",
	},
	{
		id: 2,
		name: "View Details",
	},
	{
		id: 3,
		name: "Upload a new contact list",
	},
	{
		id: 4,
		name: "Preview Upload",
	},
];

const FileUploads = () => {
	const dispatch = useDispatch();
	const [organizationId, setOrganizationId] = useState(false);
	const [employee, setEmployee] = React.useState(false);

	const [showReportId, setShowReportId] = useState(false);
	const [showErrors, setShowErrors] = React.useState(false);
	const [fetchAgain, setFetchAgain] = useState(0);
	const [deletedRecord, setDeletedRecord] = useState(0);
	const [createEdit, setCreateEdit] = useState(0);
	const [showPage, setShowPage] = useState(AllPageOptions[0]);

	const EmployeeId = useSelector(
		(state) => Number(state.auth?.employee_id),
		shallowEqual
	);
	const AmbassadorId = useSelector(
		(state) => Number(state.auth?.ambassador_id),
		shallowEqual
	);

	const {
		get_auth,
		get_selectedOrg,
		get_employee,
		get_survey_structure,
		get_errors,
	} = useSelector(
		(state) => ({
			get_errors: state.errors,
			get_auth: state.auth,
			get_employee: state.employees,
			get_selectedOrg: state.selectedOrg,
			get_survey_structure: state.surveystructure.survey_structure,
		}),
		shallowEqual
	);

	useEffect(() => {
		// Run! Like go get some data from an API.
		// dispatch({ type: SG_GET_MOODS });
		if (Number(AmbassadorId) > 0) {
			if (organizationId) {
				dispatch({
					type: LOAD_TEAMS,
					payload: `organization=${organizationId}`,
				});
				dispatch({
					type: PULL_ORGANIZATION,
					payload: { id: organizationId },
				});
				dispatch({
					type: SG_GET_FILE_UPLOADS,
					payload: `file_type=1&organization=${organizationId}`,
				});
				dispatch({
					type: SG_GET_SURVEY_STRUCTURES,
					payload: `organization=${organizationId}`,
				});
				return;
			}
		} else {
			dispatch({ type: LOAD_TEAMS });
			dispatch({
				type: SG_GET_SURVEY_STRUCTURES,
			});

			if (Number(EmployeeId) > 0) {
				dispatch({
					type: SG_GET_FILE_UPLOADS,
					payload: `file_type=1`,
				});
			}
			return;
		}
	}, [dispatch, AmbassadorId, organizationId, EmployeeId]);

	useEffect(() => {
		if (organizationId) {
			dispatch({
				type: SG_VALIDATE_ORG_EMP_EMAIL,
				payload: `organization-id=${organizationId}`,
			});
		}
	}, [dispatch, organizationId]);

	useEffect(() => {
		if (Number(AmbassadorId) > 0) {
			setOrganizationId(get_selectedOrg?.organization?.id);
		} else {
			setOrganizationId(Number(get_auth.organization_id));
		}
	}, [get_selectedOrg, AmbassadorId, get_auth]);

	useEffect(() => {
		setEmployee(get_employee[EmployeeId]);
		if (get_employee[EmployeeId]?.account_type === 5) {
			setCreateEdit(true);
			return;
		}

		if (get_employee[EmployeeId]?.role < 7) {
			setCreateEdit(true);
			return;
		}
		setCreateEdit(false);
	}, [get_employee, EmployeeId]);

	useEffect(() => {
		if (get_errors?.status === 403) {
			setShowErrors(get_errors?.data?.detail);
		}
	}, [get_errors]);

	function clearErrors() {
		dispatch({
			type: CLEAR_ERRORS,
		});
		setShowErrors(false);
	}

	const DemoFile = () => {
		saveAs(get_survey_structure?.[0]?.csv_template);
	};

	function ResettoHomePage() {
		setShowReportId(false)
		setShowPage(AllPageOptions[0])
		dispatch({
			type: CLEAR_CREATED_FILE_UPLOAD,
		});
	}

	function NewFileUpload() {
		setShowReportId(false)
		setShowPage(AllPageOptions[2])
		dispatch({
			type: CLEAR_CREATED_FILE_UPLOAD,
		});
	}

	const breadcrumbCrumbs = [
		{
			label: "Contact Upload",
			onClick: () => ResettoHomePage(),
		},
	];
	if (showPage?.name && showPage?.id !== 1) {
		breadcrumbCrumbs.push({ label: showPage.name });
	}

	return (
		<PageContainer>
			<ContactBreadcrumb crumbs={breadcrumbCrumbs} />
			{/* Error Messages */}
			{showErrors && (
				<ErrorNotification>
					<ErrorHeader>
						<ErrorIcon>⚠</ErrorIcon>
						<ErrorText>
							<ErrorTitle>There was an error</ErrorTitle>
							<ErrorMessage>{showErrors}</ErrorMessage>
						</ErrorText>
					</ErrorHeader>
					<CloseButton onClick={clearErrors}>×</CloseButton>
				</ErrorNotification>
			)}

			{/* Page Header */}
			<PageHeader>
				<HeaderContent>
					<HeaderLeft>
						<PageTitle>{showPage?.name}</PageTitle>
						<PageDescription>
							{showPage?.id === 1 && "Manage your contact upload files"}
							{showPage?.id === 2 && "Review upload details and validation results"}
							{showPage?.id === 3 && "Upload a new CSV file with contact data"}
						</PageDescription>
					</HeaderLeft>
					{showPage?.id > 1 && (
						<ClosePageButton onClick={ResettoHomePage}>
							<CloseIcon>×</CloseIcon>
							Close
						</ClosePageButton>
					)}
				</HeaderContent>
			</PageHeader>

			<BasicErrorMessage />

			{get_survey_structure?.[0]?.csv_template ? (
				<MainContent>
					{/* Upload New File Page */}
					{showPage?.id === 3 && (
						<FadeInContent>
							<Upload
								setFetchAgain={setFetchAgain}
								setShowReportId={setShowReportId}
								organizationId={organizationId}
								setShowPage={setShowPage}
								AllPageOptions={AllPageOptions}
							/>
						</FadeInContent>
					)}

					{/* Upload Details Page */}
					{showPage?.id === 2 ? (
						<FadeInContent>
							{showReportId ? (
								<Details
									showReportId={showReportId}
									get_survey_structure={get_survey_structure}
								/>
							) : (
								<EmptyState>
									<EmptyIcon>📁</EmptyIcon>
									<EmptyTitle>No upload file selected</EmptyTitle>
									<EmptyDescription>
										Please select an upload file from the list to view its details
									</EmptyDescription>
								</EmptyState>
							)}
						</FadeInContent>
					) : null}

					{/* Main Upload List Page */}
					{showPage?.id === 1 && (
						<FadeInContent>
							<ActionBar>
								<ActionButton variant="secondary" onClick={() => DemoFile()}>
									<ButtonIcon>⬇</ButtonIcon>
									Download Sample
								</ActionButton>
								<ActionButton variant="primary" onClick={NewFileUpload}>
									<ButtonIcon>⬆</ButtonIcon>
									Upload File
								</ActionButton>
							</ActionBar>
							
							<ContentSection>
								<List
									fetchAgain={fetchAgain}
									setFetchAgain={setFetchAgain}
									organizationId={organizationId}
									showErrors={showErrors}
									deletedRecord={deletedRecord}
									createEdit={createEdit}
									setDeletedRecord={setDeletedRecord}
									setShowReportId={setShowReportId}
									setShowPage={setShowPage}
									AllPageOptions={AllPageOptions}
								/>
							</ContentSection>
						</FadeInContent>
					)}
				</MainContent>
			) : (
				<WarningCard>
					<WarningIcon>⚠</WarningIcon>
					<WarningContent>
						<WarningTitle>Survey structure required</WarningTitle>
						<WarningMessage>
							We were unable to find a matching survey structure. This information needs to be uploaded before we start the uploads.
						</WarningMessage>
					</WarningContent>
				</WarningCard>
			)}
		</PageContainer>
	);
};

export default FileUploads;

// Main Layout Components
const PageContainer = styled.div`
	background: white;
	min-height: 100vh;
	padding: 24px;
	font-family: "Poppins", sans-serif;
	
	@media (max-width: 768px) {
		padding: 16px;
	}
`;

const PageHeader = styled.div`
	margin-bottom: 32px;
`;

const HeaderContent = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 24px;
`;

const HeaderLeft = styled.div`
	flex: 1;
`;

const PageTitle = styled.h1`
	font-family: "Poppins", sans-serif;
	font-weight: 700;
	font-size: 28px;
	color: #1f2937;
	margin: 0 0 8px 0;
	line-height: 1.2;
`;

const PageDescription = styled.p`
	font-family: "Poppins", sans-serif;
	font-weight: 400;
	font-size: 16px;
	color: #6b7280;
	margin: 0;
	line-height: 1.5;
`;

const ClosePageButton = styled.button`
	background: transparent;
	color: #6b7280;
	border: none;
	border-radius: 6px;
	padding: 8px 16px;
	font-family: "Poppins", sans-serif;
	font-weight: 500;
	font-size: 14px;
	cursor: pointer;
	transition: all 0.2s ease;
	display: flex;
	align-items: center;
	gap: 6px;

	&:hover {
		color: #374151;
		background: #f9fafb;
	}
`;

const CloseIcon = styled.span`
	font-size: 18px;
	line-height: 1;
`;

// Error Notification
const ErrorNotification = styled.div`
	background: #fef2f2;
	border: 1px solid #fecaca;
	border-radius: 8px;
	padding: 16px;
	margin-bottom: 24px;
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	animation: slideDown 0.3s ease-out;

	@keyframes slideDown {
		from {
			opacity: 0;
			transform: translateY(-10px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
`;

const ErrorHeader = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 12px;
`;

const ErrorIcon = styled.div`
	color: #dc2626;
	font-size: 20px;
	line-height: 1;
	margin-top: 1px;
`;

const ErrorText = styled.div`
	flex: 1;
`;

const ErrorTitle = styled.div`
	font-weight: 600;
	font-size: 14px;
	color: #dc2626;
	margin-bottom: 4px;
`;

const ErrorMessage = styled.div`
	font-size: 14px;
	color: #7f1d1d;
	line-height: 1.4;
`;

const CloseButton = styled.button`
	background: transparent;
	border: none;
	color: #dc2626;
	font-size: 20px;
	cursor: pointer;
	padding: 0;
	width: 24px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;
	transition: background-color 0.2s ease;

	&:hover {
		background: #fee2e2;
	}
`;

// Main Content
const MainContent = styled.div`
	animation: fadeIn 0.4s ease-out;

	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateY(10px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
`;

const FadeInContent = styled.div`
	animation: contentFadeIn 0.3s ease-out;

	@keyframes contentFadeIn {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
`;

// Action Bar
const ActionBar = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	margin-bottom: 32px;
	justify-content: flex-end;

	@media (max-width: 768px) {
		flex-direction: column;
		align-items: stretch;
		gap: 12px;
	}
`;

const ActionButton = styled.button`
	background: transparent;
	color: ${(props) => (props.variant === 'primary' ? '#476dfa' : '#6b7280')};
	border: none;
	border-radius: 6px;
	padding: 12px 20px;
	font-family: "Poppins", sans-serif;
	font-weight: ${(props) => (props.variant === 'primary' ? '600' : '500')};
	font-size: 14px;
	cursor: pointer;
	transition: all 0.2s ease;
	display: flex;
	align-items: center;
	gap: 8px;

	&:hover {
		color: ${(props) => (props.variant === 'primary' ? '#3d5ce6' : '#374151')};
		transform: translateY(-1px);
	}

	&:active {
		transform: translateY(0);
	}
`;

const ButtonIcon = styled.span`
	font-size: 16px;
	line-height: 1;
`;

const ContentSection = styled.div`
	/* Content wrapper for list component */
`;

// Empty State
const EmptyState = styled.div`
	text-align: center;
	padding: 64px 24px;
	color: #6b7280;
`;

const EmptyIcon = styled.div`
	font-size: 48px;
	margin-bottom: 16px;
	opacity: 0.6;
`;

const EmptyTitle = styled.h3`
	font-weight: 600;
	font-size: 18px;
	color: #374151;
	margin: 0 0 8px 0;
`;

const EmptyDescription = styled.p`
	font-size: 14px;
	color: #6b7280;
	margin: 0;
	line-height: 1.5;
`;

// Warning Card
const WarningCard = styled.div`
	background: #fffbeb;
	border: 1px solid #fed7aa;
	border-radius: 8px;
	padding: 20px;
	display: flex;
	align-items: flex-start;
	gap: 16px;
	animation: slideUp 0.3s ease-out;

	@keyframes slideUp {
		from {
			opacity: 0;
			transform: translateY(10px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
`;

const WarningIcon = styled.div`
	color: #d97706;
	font-size: 24px;
	line-height: 1;
	margin-top: 2px;
`;

const WarningContent = styled.div`
	flex: 1;
`;

const WarningTitle = styled.h3`
	font-weight: 600;
	font-size: 16px;
	color: #92400e;
	margin: 0 0 8px 0;
`;

const WarningMessage = styled.p`
	font-size: 14px;
	color: #a16207;
	margin: 0;
	line-height: 1.5;
`;
